import React, { Fragment, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ExitModalAndSave from '../Modal/ExitModalAndSave';
import Button from "../../Button/Button";
import { useDispatch, useSelector } from 'react-redux';
import { userChosenSaveExit, userChosenVandalismQuestion, workOrderData, dmcCheckSavedAnswer, fromConfirmedDampMould } from '../../ducks/redux/actions/userChoices';
import { useTranslation } from 'react-i18next';
import { WorksOrderRequest } from '../../models/WorksOrders/WorksOrderRequest';
import { Container } from 'react-bootstrap';
import classes from "../RepairUploadMedia/styles.module.css";
import styles from "../RepairUploadMedia/spinner.module.css";
import RepairJourney from '../RepairJourney';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import YellowAlert from '../YellowAlert';
import './index.css';
import * as api from "../../api";
import { removeAllDMCData, saveDuplicateDMCAnswers } from '../../ducks/redux/actions/FinancialReferral';
import { isNullOrUndefined } from "../../utils/formatting";




interface DMCCheckProps extends RouteComponentProps<any> {

}

const DMCCheck: React.FC<DMCCheckProps> = (props: any) => {
  const savedAnswer = useSelector((state: any) => state?.userChoicesReducer?.dmcCheckSavedAnswer);
  const [isLoading, setIsLoading] = useState(false);
  const [selAns, setSelAns] = useState("");
  const assetByIdDataObject = useSelector((state: any) => state?.dashboardReducer?.formState?.assetByIdDataObject);
  const vandalismConfigValue = useSelector((state: any) => state?.userChoicesReducer?.vandalismtoggleValue);
  const isRepairMedia = useSelector((state: any) => state?.userChoicesReducer?.isRepairMediaAllowed);
  const workOrderObject = useSelector((state: any) => state.addresses?.workOrderRepair);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [error, setError] = useState("");
  const priorityCodeValue = useSelector((state: any) => state.dashboardReducer.formState?.priorityCode);
  const exitButtonHandler = () => {
    dispatch(dmcCheckSavedAnswer(""));
    props.history.push("/LandingView");
  };

  const saveDraftAndExit = () => {
    dispatch(userChosenSaveExit(true))
    dispatch(fromConfirmedDampMould(true));
    UpdateWorkOrder();
    const worksOrder = new WorksOrderRequest(workOrderObject);
    dispatch(workOrderData(worksOrder))
    props.history.push(
      `/WorkOrder360View/${worksOrder.identifiers?.worksOrderIdentifier}`
    );
  };
  const backButtonHandler = () => {
    dispatch(fromConfirmedDampMould(false));
    props.history.push("/RepairAdditionalDetails");
  }

  const UpdateWorkOrder = async () => {
    if (selAns === "No") {
      // removing all dmc answers when user changes the additional information
      dispatch(removeAllDMCData(null));
    }
    try {
      setIsLoading(true);
      workOrderObject.isCausingDampAndMould = selAns === "Yes" ? true : false;
      workOrderObject.priority = priorityCodeValue
      const assessmentInformation = null
      workOrderObject.assessmentInformation = assessmentInformation;
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      )

    } catch (e) {
      console.error(e);
      props.history.push("/GenericError");
    } finally {
      setIsLoading(false);
    }
  };

  const handleContinue = () => {
    if (selAns === "") {
      setError("Please answer all the questions to continue.");
      return;
    }
    setError(""); // Clear any previous errors
    dispatch(dmcCheckSavedAnswer(selAns));
    dispatch(fromConfirmedDampMould(false)); // Save the selected answer to Redux
    UpdateWorkOrder();
    if (selAns === "Yes") {
      dispatch(saveDuplicateDMCAnswers(null));
      props.history.push("/DampAndMouldAssesment/1");
    } else if (isRepairMedia === "true") {
      props.history.push("/RepairUploadmedia");
    } else if (assetByIdDataObject?.statuses.isInDefects && vandalismConfigValue) {
      props.history.push("/VandalismQuestion");
    } else {
      dispatch(userChosenVandalismQuestion(""));
      props.history.push("/VulnerabilityQuestion");
    }
  };
useEffect(() => {     
  if (props.history.action === "POP" && savedAnswer) {
    setSelAns(savedAnswer); // browser back button with saved answer
  } else if (!isNullOrUndefined(workOrderObject?.isCausingDampAndMould)) {
    setSelAns(workOrderObject.isCausingDampAndMould ? "Yes" : "No");
  
  } else {
    setSelAns(""); // No pre-selection on first load
  }
}, [savedAnswer]);
 

  const updateSelection = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSelAns(e.target.value); //
  }



  return (
    <Container id="supp-main-container" className="ctn-fht1 sm:px-3" role="main">
      {isLoading ? (
        <div className={classes.overlay}>
          <div id="UploadingOverlay">
            <div className={styles.overlayContainer}>
              <div className={styles.overlayContent}>
                <div className={styles.spinner}></div>
              </div>
            </div>
          </div>
        </div>
      ) :
        (
          <Fragment>

            <div id="backmodal-div1" className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0" >
              <div className="back-and-journey">
                <p id="backmodal-p" className="text-teal text-xl mt-4 mb-4 md:mb-12">
                  <a className="back-btn" onClick={backButtonHandler} onKeyDown={backButtonHandler}>
                    <i className="fas fa-angle-left mr-2"></i>
                    {t("back")}
                  </a>
                </p>
                {<RepairJourney />}
              </div>
            </div>
            <div className='relative pb-2 bg-white px-1'>
              <h2 className='text-purple-100'>{t("DMC_Question")}</h2>
              <div>
                <RadioGroup
                  role="radiogroup"
                  name="radio-buttons-group"
                  className="margin-radiogroup"
                  value={selAns}
                  onChange={updateSelection}
                  data-testid="sureradioValue"
                >
                  <FormControlLabel
                    value="Yes"
                    control={<Radio className="radio-yes" id="yes-radio" />}
                    label="Yes"
                    className='wid-radio'
                    data-testid="yesRadio"
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio className="radio-no" id="no-radio" />}
                    label="No"
                    className='wid-radio'
                    data-testid="noRadio"
                  />
                </RadioGroup>
              </div>
              {
                selAns === 'Yes' &&
                <div className="alert mt-8 p-0 container" role="alert">
                  <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
                    <div className="px-4 pr-8">
                      <i className="fa fa-bullhorn text-purple-100 w-6 purple-icon"></i>
                    </div>
                    <div className="flex items-center text-black" data-testid="alertWarning">
                      <p className="w-full text-left font-AvantGardeGothic-Md">
                        {t("DMC_Trigger_Question_Alert")}
                      </p>
                    </div>
                  </div>
                </div>
              }
            </div>
            {(error !== "") && <YellowAlert messageText={t(error)} {...props} />}
            <div
              id="custDetails-main-btn"
              className="flex justify-between items-center pb-4 md:pb-8"
            >
              <ExitModalAndSave
                id="custDetails-exitmodal"
                exit={exitButtonHandler}
                saveDraftAndExit={saveDraftAndExit}
              />
              <Button
                id="btn_custmerDetails"
                onClick={handleContinue}
                onKeyDown={handleContinue}
                className="button-class"
              >
                Continue
                <i className="fas fa-angle-right relativetext-white pointer-events-none arrow"></i>
              </Button>
            </div>

          </Fragment>)}
    </Container>
  );
};

export default DMCCheck;